import { create, useModal } from '@ebay/nice-modal-react';

import ConfirmSecurityCodeModal from './ConfirmSecurityCodeModal';
import {
  CreateSecurityCodeDataProvider,
  CreateSecurityCodeStepsEnum,
  useCreateSecurityCodeDataContext,
} from './CreateSecurityCodeContext';
import SetupSecurityCodeModal from './SetupSecurityCodeModal';
import SuccessfullyCreatedSecurityCodeModal from './SuccessfullyCreatedSecurityCodeModal';

interface CreateSecurityCodeModalProps {
  onSuccess?: () => void;
  onLogout?: () => void;
  mode?: 'create' | 'change';
  showSetupDescription?: boolean;
  enforced?: boolean;
}

const CreateSecurityCodeModalInner = () => {
  const { currentStep } = useCreateSecurityCodeDataContext();

  switch (currentStep) {
    case CreateSecurityCodeStepsEnum.SETUP_PASSCODE:
      return <SetupSecurityCodeModal />;
    case CreateSecurityCodeStepsEnum.CONFIRM_PASSCODE:
      return <ConfirmSecurityCodeModal />;
    case CreateSecurityCodeStepsEnum.SUCCESSFULLY_CREATED_PASSCODE:
      return <SuccessfullyCreatedSecurityCodeModal />;
    default:
      throw new Error(`Reached unknown currentStep value: ${currentStep}`);
  }
};

const CreateSecurityCodeModal = create((props: CreateSecurityCodeModalProps) => {
  const modal = useModal(CreateSecurityCodeModal);

  return (
    <CreateSecurityCodeDataProvider
      close={modal.remove}
      onSuccess={props.onSuccess}
      onLogout={props.onLogout}
      mode={props.mode}
      showSetupDescription={props.showSetupDescription}
      enforced={props.enforced}
    >
      <CreateSecurityCodeModalInner />
    </CreateSecurityCodeDataProvider>
  );
});

export default CreateSecurityCodeModal;
